// Shim para react/jsx-runtime compatível com React 16 (CommonJS)
const React = require('react');

function jsx(type, props, key) {
  // Se houver key, adicione-o às props ou passe como argumento separado dependendo da necessidade
  // React.createElement(type, config, children)
  // No React 16, key vai no config
  const config = Object.assign({}, props);
  if (key !== undefined && key !== null) {
    config.key = key;
  }
  return React.createElement(type, config);
}

exports.jsx = jsx;
exports.jsxs = jsx; // jsxs é para static children, mesmo comportamento aqui
exports.Fragment = React.Fragment;
